import React from 'react'
import { CardImg as ReactstrapCardImg, CardImgProps } from 'reactstrap'

export const CardImg: React.FC<CardImgProps> = props => {
  return <ReactstrapCardImg {...props} />
}
